// Central content + brand config (Italiano)
export const BRAND = {
  name: "BarManProf",
  tagline: "Consulenza, Formazione ed Eventi per il mondo del bar",
  email: "bar.man.prof25@gmail.com",
  phone: "+39 366 430 7519",
  whatsapp: "393664307519",
  website: "www.barmanprof.eu",
  websiteUrl: "https://www.barmanprof.eu",
};

export const LOGO = "/media/logo-emblem.png";
export const LOGO_WORDMARK = "/media/logo-wordmark.png";
export const LOGO_AIBM = "/media/logo-aibm.png";

export const IMAGES = {
  hero: "/media/shaker-closeup.jpg",
  about: "/media/operativita.png",
  pouring: "/media/versaggio-drink.jpg",
  event: "/media/bartematico.jpg",
  cocktail: "/media/formazione-professionale.jpg",
  shelves: "/media/versaggio-drink1.jpg",
};

export const GALLERY = [
  "/media/event1.jpg",
  "/media/bartematico.jpg",
  "/media/garnish-wedding.jpg",
  "/media/versaggio-drink.jpg",
  "/media/event3.jpg",
  "/media/drink-appetizer.jpg",
  "/media/operativita2.png",
  "/media/layout-bancobar.jpg",
];

export const CONSULENZE = [
  {
    slug: "sos-servizio",
    title: "SOS Servizio",
    tagline: "Interventi mirati quando il servizio va sistemato subito",
    description:
      "Un intervento rapido e chirurgico sul tuo servizio: analizzo flussi, postazioni, tempi di erogazione e organizzazione dietro il bancone per eliminare colli di bottiglia e alzare qualità e velocità.",
    forWho: "Locali con problemi di servizio, tempi lunghi o cali di qualità nei momenti di picco.",
    includes: ["Analisi sul campo", "Riorganizzazione postazioni", "Standard di servizio", "Report con azioni pratiche"],
  },
  {
    slug: "apertura-drink",
    title: "Apertura Drink",
    tagline: "Dal concept alla drink list, pronti all'apertura",
    description:
      "Ti accompagno nell'apertura o nel restyling del bar: concept, drink list, costi e food cost, attrezzatura, formazione iniziale dello staff e definizione dell'identità del locale.",
    forWho: "Nuove aperture, restyling o locali che vogliono ripartire con un'identità forte.",
    includes: ["Concept & posizionamento", "Drink list & pricing", "Lista attrezzatura", "Formazione base staff"],
  },
  {
    slug: "performance-mensile",
    title: "Performance Mensile",
    tagline: "Un partner fisso che fa crescere il tuo bar ogni mese",
    description:
      "Affiancamento continuativo con obiettivi misurabili: revisione periodica della carta, controllo dei margini, aggiornamento dello staff e monitoraggio dei risultati mese dopo mese.",
    forWho: "Locali che vogliono crescere con costanza e avere un riferimento fisso.",
    includes: ["Visite mensili", "KPI & marginalità", "Aggiornamento carta", "Coaching continuo staff"],
  },
  {
    slug: "mentoring",
    title: "Mentoring",
    tagline: "Percorso 1:1 per barman e futuri professionisti",
    description:
      "Un percorso personalizzato di crescita professionale: tecnica, mentalità, gestione del servizio e sviluppo di carriera per chi vuole diventare un vero professionista del bar.",
    forWho: "Barman, aspiranti bar manager e professionisti che vogliono fare il salto.",
    includes: ["Sessioni 1:1", "Piano di crescita", "Tecnica & mindset", "Supporto continuo"],
  },
];

export const FORMAZIONE = [
  {
    title: "Per Locali & Staff",
    description: "Formazione on-site per il team: tecnica di base e avanzata, servizio, organizzazione, standard di qualità e mixology applicata al tuo menu.",
    points: ["Tecnica dietro il bancone", "Servizio & velocità", "Standard e qualità costante"],
  },
  {
    title: "Per Aziende",
    description: "Percorsi formativi e team building a tema bar per aziende: esperienze coinvolgenti che uniscono formazione, cultura del prodotto e spirito di squadra.",
    points: ["Team building tematici", "Cultura del prodotto", "Format su misura"],
  },
  {
    title: "Per Privati",
    description: "Corsi per appassionati che vogliono imparare a preparare grandi drink a casa: basi, tecniche, attrezzatura e ricette d'autore in un percorso pratico.",
    points: ["Basi & tecnica", "Attrezzatura casalinga", "Ricette d'autore"],
  },
  {
    title: "Per Professionisti",
    description: "Aggiornamento avanzato per chi lavora nel settore: nuove tecniche, tendenze, gestione della carta e crescita professionale certificata.",
    points: ["Tecniche avanzate", "Trend & innovazione", "Crescita di carriera"],
  },
  {
    title: "Per Team di Ristoranti",
    description: "Formazione dedicata alle squadre di sala e bar dei ristoranti: tecniche di servizio, definizione di ruoli e responsabilità, pianificazione del lavoro e SOP (procedure operative standard) per un servizio fluido e coerente.",
    points: ["Tecniche di servizio", "Ruoli & responsabilità", "Pianificazione & SOP"],
  },
];

export const EVENTI = [
  {
    tier: "Entry",
    title: "Open Bar Essential",
    price: "Su richiesta",
    description: "Postazione bar professionale con selezione di cocktail classici e signature. Perfetto per eventi privati e feste dallo stile curato.",
    features: ["Bar attrezzato", "Cocktail classici & signature", "1 bartender", "Bicchieri & ghiaccio inclusi"],
    featured: false,
  },
  {
    tier: "Mid",
    title: "Open Bar Signature",
    price: "Su richiesta",
    description: "Un'esperienza completa con drink list personalizzata sul tema dell'evento, allestimento curato e servizio ampliato per accogliere più ospiti.",
    features: ["Drink list personalizzata", "Allestimento a tema", "2 bartender", "Garnish & finiture premium", "Analcolici d'autore"],
    featured: true,
  },
  {
    tier: "Premium",
    title: "Open Bar Experience",
    price: "Su richiesta",
    description: "L'Open Bar tematico nella sua forma più spettacolare: concept dedicato, mise en place scenografica, drink d'autore e uno show che diventa protagonista.",
    features: ["Concept & storytelling", "Mise en place scenografica", "Team completo", "Drink d'autore & show", "Consulenza pre-evento"],
    featured: false,
  },
];

export const VALUES = [
  { title: "20 anni sul campo", text: "Due decenni tra bancone, sala e gestione: esperienza reale, non solo teoria." },
  { title: "Docente & Formatore", text: "Formo staff, aziende e professionisti trasferendo metodo e standard concreti." },
  { title: "Socio AIBM", text: "Parte attiva della community professionale, sempre aggiornato sulle tendenze." },
  { title: "Orientato ai risultati", text: "Non estetica fine a se stessa: risolvo problemi e faccio crescere i numeri." },
];

export const TESTIMONIALS = [
  { name: "Marco R.", role: "Titolare, Lounge Bar", text: "In poche settimane il servizio è cambiato completamente. Tempi più rapidi, staff più sicuro e clienti più soddisfatti." },
  { name: "Giulia & Andrea", role: "Sposi", text: "L'Open Bar tematico al nostro matrimonio è stato il momento più commentato della serata. Professionale e spettacolare." },
  { name: "Elena T.", role: "HR Manager", text: "Un team building diverso dal solito: divertente, curato e formativo. Il team ne parla ancora." },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/chi-sono", label: "Chi sono" },
  { to: "/consulenze", label: "Consulenze" },
  { to: "/formazione", label: "Formazione" },
  { to: "/eventi", label: "Eventi" },
  { to: "/news", label: "News" },
  { to: "/contatti", label: "Contatti" },
];
